import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectCost } from '../../../features/project/model/project-cost';
import { ProjectDetails } from '../../../features/project/model/project-details';
import { HttpProvider } from '../../common/http/http-provider.service';
import { DownloadDoc } from '../../../shared/model/sharepoint-document';
import { ProjectApprovalDTO, ProjectApproveDTO } from '../../../features/project/model/project-approval';
import { ProjectFilterDTO } from '../../../features/project/model/project-filter';
import { ProjectComment } from '../../../features/project/model/project-comments';
import { ProjectModifications } from '../../../features/project/model/project-modifications';

@Injectable()
export class ProjectDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  getProjectEstimatedCost(pId: number) {
    return this.get('project/projectCost/' + pId);
  }
  getProjectElement(pId: number, testId: number, certificateId: number) {
    // let querystr = '';
    // querystr =
    //   pId == 0
    //     ? testId == 0
    //       ? 'testId=' + testId
    //       : certificateId == 0
    //       ? ''
    //       : 'certificateId=' + certificateId
    //     : 'projectId=' + pId;
    return this.get('projectElement?projectId=' + pId);
  }
  getProjectElementbyId(id: number) {
    return this.get('projectElement?Id=' + id);
  }

  saveProjectDetails(prjDetails: ProjectDetails) {
    if (!prjDetails?.id || prjDetails?.id == 0)
      return this.post('project/Save', prjDetails);
    else
      return this.put('project/Save', prjDetails);
    //if(!parameter.id) return this.post('projects', parameter);
    //else return this.put('projects/' + parameter.id, parameter);
  }
  getProjectDetails(id: number) {
    return this.get('project/' + id);
  }

  saveProjectEstimatedCost(prjEstCost: ProjectCost[]) {
    return this.post('project/SaveEstimatedCost', prjEstCost);
  }
  saveProjectCost(prjEstCost: ProjectCost) {
    return new Promise<any>((resolve) => {
      this.post<any>(`project/UpdateCost`, prjEstCost)
        .subscribe((data: any) => {
          var result = data.result;
          resolve(result);
        },
          (error) => {
            resolve(undefined);
          });
    });
    //  return this.post('project/UpdateCost', prjEstCost);
  }
  deleteProjectEstimatedCost(projectId: number, ids: number[]) {
    return this.post('project/DeleteCost/' + projectId, ids);
  }


  saveProjectValidators(parameter: any) {
    return this.post('projectVallidator', parameter);
  }
  saveProjectDocuments(parameter: any[]) {
    return this.post('projectDocuments', parameter);
  }

  saveProjectElement(parameter: any) {
    if (!parameter.id || parameter.id == 0)
      return this.post('constructionElement/SaveConstructionElement', parameter);
    else
      return this.put('constructionElement/UpdateConstructionElement/' + parameter.id, parameter);
    // return this.post('testElement', parameter);
  }
  // getWorkGroups(id:number){
  //   return this.get(`masters/getOrganisationalWiseWrkGroup/${id}`);
  // }

  //#region project Dasboard /Test/Certificate screen
  deleteProject(projectId: number) {
    return this.delete(`project/${projectId}`);
  }
  getProjectDashboardDetails(params) {    
    return this.get('project/allProjects',  params);       
  }

  getOvewView(pId: number) {
    return this.get('project/overview/' + pId);
  }

  getTestCertTracking(pId: number) {
    return this.get('project/getTestCertTracking/' + pId);
  }

  getAllTest(pId: number) {
    return this.get('test/getAllTestbyProject/' + pId);
  }

  getAllCertificate(projectId: number) {
    return this.get('certificate/getCertificatebyProject/' + projectId);
  }

  getAllTestElement(projectId: number) {
    return this.get('constructionElement/GetElementsForProject?module=2&entity=' + projectId);
  }

  getAllCerElement(projectId: number) {
    return this.get('constructionElement/GetElementsForProject?module=3&entity=' + projectId);
  }

  saveSharepointFile(data: any) {
    // let headers = new HttpHeaders();
    // headers.append('Content-Type', 'multipart/form-data');
    // , {headers: headers}
    return this.post('project/projectDocuments', data);
  }

  getAllDocuments(projectId: number) {
    return this.get('project/GetAllDocuments/' + projectId);
  }

  downloadDocument(file: DownloadDoc) {
    return this.getFile<any>('project/DownloadDocument', file);
  }

  getApproverUsers(groupId: any, projectId: number) {
    return this.get('project/GetApproverUsers/' + projectId);
  }

  saveApproverDetails(projectApprover: ProjectApproveDTO[], projectId: number) {
    return this.post('project/RequestApproval/' + projectId, projectApprover);
  }

  getProjectApproverDetails(projectId: number) {
    return this.get('project/GetProjectApproverDetails/' + projectId);
  }

  validateProject(projectApproval: ProjectApproveDTO[], projectId: number) {
    console.log("validateprojectdetails")
    console.log("projectApproval", projectApproval)
    console.log("projectId",projectId)
    return this.post('project/ValidateProject/' + projectId, projectApproval);
  }

  saveProjectNumber(projectId: number, projectNumber: string) {
    return this.post('project/UpdateProjectNumber', { projectId: projectId, projectNumber: projectNumber })
  }

  closeProject(projectId: number) {
    return this.post('project/Close/' + projectId, {});
  }

  getApprovalGroups(organisationalUnitId: number) {
    return this.get('group/GetApprovalGroups/' + organisationalUnitId);
  }

  getSelectedReadGroups(organisationalUnitId: number, confidentialityLvlId: number) {
    return this.get('group/GetSelectedReadGroups/' + organisationalUnitId, { confidentialityLvlId: confidentialityLvlId })
  }
  search(data: ProjectFilterDTO) {
    return this.post('project/search/', data);
  }

   export(data: ProjectFilterDTO) {
      return this.getFile<any>('project/export', data);
  }
  

  saveComment(comment: ProjectComment){
    return this.post('project/saveComment', comment);
  }

  saveModifications(modifications: ProjectModifications){
    return this.post('project/saveModifications', modifications);
  }

  deleteComment(commentId: number, projectId: number){
    return this.delete(`project/DeleteComment/` + commentId + `/` + projectId);
  }
  
  getProjectComments(projectId: number) {
    return this.get('project/projectComments/' + projectId);
  }

  getProjectModifications(projectId: number) {
    return this.get('project/projectModifications/' + projectId);
  }
  //#endregion project Dasboard/Test/Certificate screen

  addToFavorites(projectId: number) {
    return this.post('project/addToFavorites/' + projectId, {});
  }

  removeFromFavorites(projectId: number) {
    return this.delete('project/removeFromFavorites/' + projectId);
  }

  resetProjectValidation(projectId: number) {
    return this.put('project/ResetProjectApprovers?projectId=' + projectId, null);
  }


}
